import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Box, Button, Grid } from "@mui/material";

function CenterAccordions({
  id,
  title = "",
  details = "",
  onProfileClick = () => {},
  openAccordions = false,
}) {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(openAccordions);
  }, [openAccordions]);

  return (
    <Box
      borderRadius="16px"
      overflow="hidden"
      style={{
        overflow: "hidden",
        border: "1px solid rgba(157, 167, 232, 0.2)",
        boxShadow: "2px 3px 10px rgba(50, 50, 50, 0.1)",
      }}
      my={1}
      flex={1}
    >
      <Accordion expanded={expanded} onClick={() => setExpanded(!expanded)}>
        <AccordionSummary
          expandIcon={<MdKeyboardArrowDown fontSize="1.8rem" />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Grid
            width="100%"
            display="flex"
            flexDirection={{ xs: "column-reverse", sm: "row" }}
            justifyContent={{ xs: "center", sm: "space-between" }}
            alignItems="center"
          >
            <Grid item xs={12} sm={1}>
              <Button
                onClick={() => {
                  onProfileClick();
                  navigate(`/center-profile/${id}?name=${title}`);
                }}
                variant="s2"
                sx={{
                  backgroundColor: "#EBEDFA",
                  color: "rgba(76, 70, 111, 0.5)",
                  borderRadius: 2,
                  whiteSpace: "nowrap",
                }}
              >
                رزومه مرکز
              </Button>
            </Grid>
            <Grid item xs={12} sm={10.1} mb={{ xs: 1, sm: 0 }}>
              <Typography variant="h2" textAlign="right" w="100%">
                {title}
              </Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="h2" textAlign="right">
            {details}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

CenterAccordions.propTypes = {
  title: PropTypes.string,
  details: PropTypes.string,
  onProfileClick: PropTypes.func,
};

export default CenterAccordions;
